import React from 'react';
import TextArea from 'components/shared/debouncedTextArea';
import Header from './Header';
import Footer from './Footer';

const Question = ({
  prompt,
  updatePrompt,
  questionType,
  feedbackCriteria,
  updateFeedbackCriteria,
  features,
}) => (
  <div className="EditorElement-content">
    <Header title={t(`questions.types.${questionType}.title`)} />
    <div className="EditorElement-body">
      <TextArea
        className="EditorElement-input"
        placeholder={t('questions.element.enter_prompt')}
        value={prompt}
        onChange={updatePrompt}
        singleLine
      />
    </div>
    <Footer
      feedbackCriteria={feedbackCriteria}
      updateFeedbackCriteria={updateFeedbackCriteria}
      features={features}
      hint={t(`questions.types.${questionType}.hint`)}
    />
  </div>
);

export default Question;
